<app-modal-v2 #modal customClassName="diary-form-element-settings-modal">
    <div class="modal-content">

        <div class="modal-header">
            <div class="culture-select">
                <app-input-select #cultureSelect [items]="filteredCultures" [parentForm]="form" controlName="selectedCulture" [allowFiltering]="true" [allowClear]="false" (onFilter)="onCultureFiltered($event)" searchInputPlaceholder="Search..."></app-input-select>
            </div>

            <div>
                <form [formGroup]="form">
                    <app-checkbox formControlName="isRequired" label="Required" [labelBefore]="true"/>
                </form>
            </div>
        </div>
        <div class="modal-body">
            <!-- Start: Default Form -->
            <form [formGroup]="form" [ngClass]="{'visibility-hidden': form.value.selectedCulture !== 'en'}">
                <div class="form-group">
                    <label for="name">Question <sup>*</sup></label>
                    <div class="fake-field disabled" [class.visibility-hidden]="elementIsEditable()">{{ this.form.get('label').value }}</div>
                    <input type="text" formControlName="label" class="form-control" [class.visibility-hidden]="!elementIsEditable()"/>
                </div>

                <div class="form-group" [ngClass]="{'visibility-hidden': !shouldShowPlaceholder()}">
                    <label for="name">Placeholder</label>
                    <div class="fake-field disabled" [class.visibility-hidden]="elementIsEditable()">{{ this.form.get('placeholder').value }}</div>
                    <input type="text" formControlName="placeholder" class="form-control" [class.visibility-hidden]="!elementIsEditable()"/>
                </div>

                <!-- Start: Completion Answer -->
                <div class="form-group" *ngIf="isOnboardingQuestions && isCompletionAnswerSupported()">
                    <label>Completion Answer <sup *ngIf="editable">*</sup></label>
                    <ng-container *ngIf="element?.elementType === DiaryFormElementType.Numeric">
                        <div class="fake-field disabled" [class.visibility-hidden]="elementIsEditable()">{{ form.get('completionValue').value }}</div>
                        <input type="number" class="form-control" formControlName="completionValue" [class.visibility-hidden]="!elementIsEditable()" />
                    </ng-container>
                    <ng-container *ngIf="isOptionBasedCompletion()">
                        <div class="fake-field disabled" [class.visibility-hidden]="elementIsEditable()">{{ selectedCompletionOptionText }}</div>
                        <app-dropdown-input
                            [class.visibility-hidden]="!elementIsEditable()"
                            [options]="completionOptions"
                            [parentForm]="form"
                            [selectedValue]="form.get('completionOptionId').value || ''"
                            name="completionOptionId"
                            [canClear]="true"
                            placeholder="Select completion answer...">
                        </app-dropdown-input>
                    </ng-container>
                </div>
                <!-- End: Completion Answer -->
            </form>
            <!-- End: Default Form -->

            <!-- Start: Culture Forms -->
            <ng-container *ngFor="let cultureForm of cultureForms">
                <form [formGroup]="cultureForm" [ngClass]="{'visibility-hidden': cultureForm.value.culture !== form.value.selectedCulture}">
                    <div class="form-group">
                        <label for="name">Question <sup>*</sup></label>
                      <div class="fake-field disabled" [class.visibility-hidden]="labelIsEditable()">{{ cultureForm.get('label').value }}</div>
                        <input type="text" formControlName="label" class="form-control" [class.visibility-hidden]="!labelIsEditable()"/>
                    </div>

                    <div class="form-group" [ngClass]="{'visibility-hidden': !shouldShowPlaceholder()}">
                        <label for="name">Placeholder</label>
                        <div class="fake-field disabled" [class.visibility-hidden]="placeholderIsEditable()">{{ cultureForm.get('placeholder').value }}</div>
                        <input type="text" formControlName="placeholder" class="form-control" [class.visibility-hidden]="!placeholderIsEditable()"/>
                    </div>
                </form>
            </ng-container>
            <!-- End: Culture Forms -->

            <!-- Start: Options Management -->
            <div class="form-group" *ngIf="showOptionsSection">
                <app-element-option-list [editable]="editable" [element]="element" [culture]="form.value.selectedCulture" />
            </div>
            <!-- End: Options Management -->
        </div>

        <div class="modal-footer">
            <div class="modal-footer-buttons">
                <app-button text="Cancel" variant="secondary" width="fill"
                            type="button" (click)="closeManageElementModal()"/>

                <app-button text="Update" variant="primary" width="fill"
                            [disabled]="!form.valid || !elementOptionsValid()"
                            type="button"
                            (click)="onUpdateElementSettings()"/>
            </div>
        </div>

    </div>
</app-modal-v2>
